import React, { useEffect, useState } from 'react'
import { FaRegTrashAlt } from 'react-icons/fa'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import {
  Btn,
  BtnIcon,
  Cnpj,
  CustomCheckbox,
  CustomDataTableHeader,
  CustomDropdown,
  CustomModal,
  CustomPanel,
  CustomTabView,
  InputCep,
  InputCnpj,
  InputNumeroInteiro,
  InputPhone,
  InputText,
  Loading,
  PageHeader,
} from '../../../../components'

import { showMessageBox, showLoadingBox, hideLoadingBox } from '../../../../store/actions/system.actions'
import * as CompanyCnpjHttp from '../../../../services/api/https/system/company-cnpj.system.http'
import * as EmpresaHttp from '../../../../services/api/https/settings/company.http'
import * as SystemHttp from '../../../../services/api/https/system/system.http'

import { errorHandler } from '../../../../services/util/error.service'
import { TabPanel } from 'primereact/tabview'
import {
  getAssocTiposArquivoComEmpresa,
  getCnpjDataFocusNfe,
  handleAssocTiposArquivoComEmpresa,
} from '../../../../services/api/https/system/system.http'
import { tableCellCentered } from '../../../../assets/js/styles'
import { vinho } from '../../../../assets/js/colors'

function Empresa({ dispatch, history }) {
  // Vars
  const initEmpresa = {
    id: null,
    name: '',
    cnpj: '',
    actived: true,
    qte_caixas_por_pallet: '',
    sigla: '',
    company_code: '',
    razao_social: '',
    phone: '(__)_____-____',
    address: '',
    number: '',
    district: '',
    city_id: '',
    uf_id: '',
    cep: '',
    inscricao_estadual: '',
    generic_product_code: '',
    enviar_email_cte: false,
    email_destinatario_cte: '',
    business_unit: '',
  }

  // Hooks
  const [isLoading, setIsLoading] = useState(false)
  const [empresas, setEmpresas] = useState([])
  const [selectedEmpresa, setSelectedEmpresa] = useState(initEmpresa)
  const [showModal, setShowModal] = useState(false)
  useEffect(() => {
    getEmpresas()
  }, [])

  // Events
  const onBtnNovo = () => {
    setSelectedEmpresa(initEmpresa)
    setShowModal(true)
  }

  const onModalClose = () => {
    setShowModal(false)
  }

  const onModalSave = async empresa => {
    const index = empresas.findIndex(l => l.id === empresa.id)
    if (index !== -1) {
      const nEmpresas = [...empresas]
      nEmpresas[index] = empresa
      setEmpresas(nEmpresas)
    } else {
      setEmpresas([...empresas, empresa])
    }
    setShowModal(false)
  }

  const onModalError = error => {
    dispatch(showMessageBox(null, error))
  }

  const onRowClicked = empresa => {
    setSelectedEmpresa({
      ...empresa,
      id: empresa.id,
      name: empresa.name || '',
      cnpj: empresa.cnpj || '',
      actived: empresa.actived,
      qte_caixas_por_pallet: empresa.qte_caixas_por_pallet,
      sigla: empresa.sigla || '',
      company_code: empresa.company_code || '',
      razao_social: empresa.razao_social || '',
      phone: empresa.phone || '(__)_____-____',
      address: empresa.address || '',
      number: empresa.number || '',
      district: empresa.district || '',
      city_id: empresa.city_id || '',
      uf_id: empresa.uf_id || '',
      cep: empresa.cep || '',
      inscricao_estadual: empresa.inscricao_estadual || '',
      generic_product_code: empresa.generic_product_code || '',
      enviar_email_cte: !!empresa.enviar_email_cte,
      email_destinatario_cte: empresa.email_destinatario_cte || '',
      business_unit: empresa.business_unit || '',
    })
    setShowModal(true)
  }

  // Helpers
  const getEmpresas = async () => {
    try {
      setIsLoading(true)
      const fetchedEmpresas = await EmpresaHttp.getCompanies()

      setEmpresas(fetchedEmpresas)
    } catch (error) {
      this.props.dispatch(showMessageBox(null, error))
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div>
      <PageHeader>S.4 - Gestão de Empresas</PageHeader>
      <div style={{ marginTop: 20 }}>
        <CustomPanel onNovo={onBtnNovo} onVoltar={history.goBack}>
          {isLoading ? (
            <div className="text-center">
              <Loading size="md" />
            </div>
          ) : (
            <EmpresaDataTable empresas={empresas} onRowClick={onRowClicked} />
          )}
        </CustomPanel>
      </div>
      <EmpresaModal
        isVisible={showModal}
        onError={onModalError}
        onSuccess={onModalSave}
        onClose={onModalClose}
        empresa={selectedEmpresa}
        dispatch={dispatch}
      />
    </div>
  )
}

function EmpresaModal({ empresa, isVisible, onClose, onSuccess, onError, dispatch }) {
  const [activeIndex, setActiveIndex] = useState(0)
  const [selectedEmpresa, setSelectedEmpresa] = useState(empresa)

  useEffect(() => {
    setSelectedEmpresa(empresa)
  }, [empresa])
  // Render
  return (
    <CustomModal
      width={800}
      header="Empresa"
      isVisible={isVisible}
      onClose={() => {
        setActiveIndex(0)
        onClose()
      }}
    >
      <CustomTabView activeIndex={activeIndex} onTabChange={value => setActiveIndex(value)}>
        <TabPanel header="Dados">
          <DadosTab
            empresa={empresa}
            onSuccess={onSuccess}
            onError={onError}
            selectedEmpresa={selectedEmpresa}
            setSelectedEmpresa={setSelectedEmpresa}
          />
        </TabPanel>
        <TabPanel header="Informações Adicionais">
          <AdicionaisTab
            onSuccess={onSuccess}
            onError={onError}
            selectedEmpresa={selectedEmpresa}
            setSelectedEmpresa={setSelectedEmpresa}
          />
        </TabPanel>
        <TabPanel disabled={!empresa.id} header="Arq. Importação">
          <TipoArquivoImportacaoTab onError={onError} empresaId={empresa.id} />
        </TabPanel>
        <TabPanel disabled={!empresa.id} header="CNPJs Secundários">
          <CnpjsSecundariosTab empresa={empresa} dispatch={dispatch} />
        </TabPanel>
      </CustomTabView>
    </CustomModal>
  )
}

function DadosTab({ empresa, onSuccess, onError, selectedEmpresa, setSelectedEmpresa }) {
  // Hooks
  const [state, setState] = useState({
    ufs: [],
    selectedUf: null,
    selectedCity: null,
    cities: [],
  })

  useEffect(() => {
    const loadUfCity = async () => {
      await fetchUFs(empresa.uf_id)
      if (empresa.city_id) await fetchCities(empresa.uf_id)
    }
    setState({
      ufs: [],
      selectedUf: null,
      selectedCity: null,
      cities: [],
    })
    loadUfCity()
  }, [empresa])

  useEffect(() => {
    if (selectedEmpresa.uf_id && typeof selectedEmpresa.uf_id === 'string')
      setState(prevState => ({
        ...prevState,
        selectedUf: state.ufs.find(uf => uf.uf === selectedEmpresa.uf_id),
      }))
  }, [selectedEmpresa.uf_id])

  useEffect(() => {
    if (state.selectedUf) fetchCities(state.selectedUf.id)
  }, [state.selectedUf])

  // Events
  const onBtnSalvarClicked = async () => {
    try {
      const {
        id,
        name, // Definindo valor padrão vazio para evitar undefined
        actived,
        cnpj,
        allow_duplicated_ean,
        oc_nf_dev_total,
        qte_caixas_por_pallet,
        enabled_desdobramento_produto,
        sigla,
        company_code,
        razao_social,
        phone,
        address,
        number,
        district,
        city_id,
        cep,
        inscricao_estadual,
        enviar_email_cte,
        email_destinatario_cte,
      } = selectedEmpresa

      if (name.trim().length < 3)
        throw new Error('Nome da Empresa deve conter pelo menos 3 caracteres')
      if (cnpj.trim() === '') throw new Error('CNPJ é obrigatório')
      if (razao_social.trim() === '') throw new Error('Razão Social é obrigatória')
      if (phone.trim() === '(__)_____-____') throw new Error('Telefone é obrigatório')
      if (cep.trim() === '') throw new Error('CEP é obrigatório')
      if (address.trim() === '') throw new Error('Endereço é obrigatório')
      if (number.trim() === '') throw new Error('Número do endereço é obrigatório')
      if (district.trim() === '') throw new Error('Bairro é obrigatório')
      if (city_id === null || city_id === '') throw new Error('Cidade é obrigatória')
      if (inscricao_estadual.trim() === '') throw new Error('Inscrição Estadual é obrigatória')
      if (!qte_caixas_por_pallet) throw new Error('Quantidade de Caixas por Pallet é obrigatória')
      if (sigla.trim() === '') throw new Error('Sigla é obrigatória')
      if (company_code.trim() === '') throw new Error('Company Code é obrigatório')

      const { company } = await EmpresaHttp.saveCompany({
        id,
        name,
        actived,
        cnpj,
        allow_duplicated_ean,
        oc_nf_dev_total,
        qte_caixas_por_pallet,
        enabled_desdobramento_produto,
        sigla,
        company_code,
        razao_social,
        phone: phone.replace(/\D/g, ''),
        address,
        number,
        district,
        city_id,
        cep,
        inscricao_estadual,
        enviar_email_cte,
        email_destinatario_cte,
      })
      onSuccess({ ...company, uf_id: state.selectedUf.id })
    } catch (error) {
      onError(errorHandler(error))
    }
  }

  const fetchUFs = async (ufId = null) => {
    await SystemHttp.getUfs()
      .then(ufs => {
        if (ufId)
          setState(prevState => ({
            ...prevState,
            ufs: ufs,
            selectedUf: ufs.find(uf => uf.id === ufId),
          }))
        else setState(prevState => ({ ...prevState, ufs: ufs }))
      })
      .catch(err => setState(prevState => ({ ...prevState, errorMessage: errorHandler(err) })))
  }

  const fetchCities = async ufId => {
    await SystemHttp.getCities(ufId)
      .then(cities => {
        if (selectedEmpresa.city_id)
          setState(prevState => ({
            ...prevState,
            cities: cities,
            selectedCity: cities.find(city => city.id === Number(selectedEmpresa.city_id)),
          }))
        else setState(prevState => ({ ...prevState, cities: cities }))
      })
      .catch(err => setState(prevState => ({ ...prevState, errorMessage: errorHandler(err) })))
  }

  const fetchCnpjData = async cnpj => {
    getCnpjDataFocusNfe(cnpj)
      .then(res => {
        setSelectedEmpresa(prevState => ({
          ...prevState,
          name: selectedEmpresa.id ? prevState.name : res.razao_social,
          razao_social: res.razao_social,
          cep: res.endereco.cep,
          address: res.endereco.logradouro,
          district: res.endereco.bairro,
          number: res.endereco.numero,
          city_id: res.endereco.codigo_ibge,
          uf_id: res.endereco.uf,
        }))
      })
      .catch(err => onError(err))
  }

  const onCnpjChange = cnpj => {
    setSelectedEmpresa({
      ...selectedEmpresa,
      cnpj,
    })
    if (cnpj.length === 14) fetchCnpjData(cnpj)
  }

  // Render
  return (
    <form className="p-grid">
      <div className="p-md-6 p-col-12">
        <InputCnpj
          label="CNPJ :"
          marginTop={10}
          value={selectedEmpresa.cnpj}
          onChange={({ value }) => onCnpjChange(value)}
        />
      </div>
      <div className="p-md-6 p-col-12">
        <InputText
          label="Descrição :*"
          marginTop={10}
          value={selectedEmpresa.name}
          onChange={value => setSelectedEmpresa({ ...selectedEmpresa, name: value })}
        />
      </div>
      <div className="p-md-4 p-col-12">
        <InputText
          label="Razão Social :*"
          marginTop={10}
          value={selectedEmpresa.razao_social}
          onChange={value => setSelectedEmpresa({ ...selectedEmpresa, razao_social: value })}
        />
      </div>
      <div className="p-md-4 p-col-12">
        <InputPhone
          label="Telefone :*"
          marginTop={10}
          value={selectedEmpresa.phone}
          onChange={value => setSelectedEmpresa({ ...selectedEmpresa, phone: value })}
        />
      </div>
      <div className="p-md-4 p-col-12">
        <InputCep
          label="CEP :*"
          marginTop={10}
          value={selectedEmpresa.cep}
          onChange={value => {
            setSelectedEmpresa({ ...selectedEmpresa, cep: value.value })
          }}
        />
      </div>
      <div className="p-md-4 p-col-12">
        <InputText
          label="Endereço :*"
          marginTop={10}
          value={selectedEmpresa.address}
          onChange={value => setSelectedEmpresa({ ...selectedEmpresa, address: value })}
        />
      </div>
      <div className="p-md-4 p-col-12">
        <InputText
          label="Número :*"
          marginTop={10}
          value={selectedEmpresa.number}
          onChange={value => setSelectedEmpresa({ ...selectedEmpresa, number: value })}
        />
      </div>
      <div className="p-md-4 p-col-12">
        <InputText
          label="Bairro :*"
          marginTop={10}
          value={selectedEmpresa.district}
          onChange={value => setSelectedEmpresa({ ...selectedEmpresa, district: value })}
        />
      </div>
      <div className="p-md-4 p-col-12">
        <CustomDropdown
          optionLabel="name"
          options={state.ufs}
          value={state.selectedUf}
          label="Estado :*"
          filter={true}
          onChange={value => {
            setState(prevState => {
              prevState.selectedUf = value
              return { ...prevState }
            })
          }}
        />
      </div>
      <div className="p-md-4 p-col-12">
        <CustomDropdown
          disabled={!state.selectedUf}
          optionLabel="name"
          options={state.cities}
          value={state.selectedCity}
          label="Cidade :*"
          filter={true}
          onChange={value => {
            setState(prevState => {
              prevState.selectedCity = value
              return { ...prevState }
            })
            setSelectedEmpresa({ ...selectedEmpresa, city_id: value.id })
          }}
        />
      </div>
      <div className="p-md-4 p-col-12">
        <InputText
          label="Inscrição Estadual :*"
          marginTop={10}
          value={selectedEmpresa.inscricao_estadual}
          onChange={value => setSelectedEmpresa({ ...selectedEmpresa, inscricao_estadual: value })}
        />
      </div>
      <div className="p-col-6">
        <InputNumeroInteiro
          marginTop={10}
          label="Qte de Caixas Por Pallet:*"
          value={selectedEmpresa.qte_caixas_por_pallet}
          onChange={value =>
            setSelectedEmpresa({ ...selectedEmpresa, qte_caixas_por_pallet: value })
          }
        />
      </div>
      <div className="p-col-6" style={{ marginTop: 33 }}>
        <CustomCheckbox
          onChange={value => setSelectedEmpresa({ ...selectedEmpresa, actived: value })}
          checked={selectedEmpresa.actived}
        >
          Ativo
        </CustomCheckbox>
      </div>

      <div className="p-col-12">
        <Btn onClick={onBtnSalvarClicked}>Salvar</Btn>
      </div>
    </form>
  )
}

function AdicionaisTab({ onSuccess, onError, selectedEmpresa, setSelectedEmpresa }) {
  // Events
  const onBtnSalvarClicked = async () => {
    try {
      const {
        id,
        name, // Definindo valor padrão vazio para evitar undefined
        actived,
        cnpj,
        allow_duplicated_ean,
        oc_nf_dev_total,
        qte_caixas_por_pallet,
        enabled_desdobramento_produto,
        sigla,
        company_code,
        razao_social,
        phone,
        address,
        number,
        district,
        city_id,
        cep,
        inscricao_estadual,
        generic_product_code,
        enviar_email_cte,
        email_destinatario_cte,
        business_unit,
      } = selectedEmpresa

      if (name.trim().length < 3)
        throw new Error('Nome da Empresa deve conter pelo menos 3 caracteres')
      if (cnpj.trim() === '') throw new Error('CNPJ é obrigatório')
      if (razao_social.trim() === '') throw new Error('Razão Social é obrigatória')
      if (phone.trim() === '(__)_____-____') throw new Error('Telefone é obrigatório')
      if (cep.trim() === '') throw new Error('CEP é obrigatório')
      if (address.trim() === '') throw new Error('Endereço é obrigatório')
      if (number.trim() === '') throw new Error('Número do endereço é obrigatório')
      if (district.trim() === '') throw new Error('Bairro é obrigatório')
      if (city_id === null || city_id === '') throw new Error('Cidade é obrigatória')
      if (inscricao_estadual.trim() === '') throw new Error('Inscrição Estadual é obrigatória')
      if (!qte_caixas_por_pallet) throw new Error('Quantidade de Caixas por Pallet é obrigatória')
      if (sigla.trim() === '') throw new Error('Sigla é obrigatória')
      if (company_code.trim() === '') throw new Error('Company Code é obrigatório')
      if (enviar_email_cte) {
        const destinatario = (email_destinatario_cte || '').trim()
        if (destinatario === '')
          throw new Error(
            'Destinatário é obrigatório quando o envio de email ao emitir CTE está ativo',
          )
        if (!/^\S+@\S+\.\S+$/.test(destinatario))
          throw new Error('Destinatário do email de CTe inválido')
      }

      const { company } = await EmpresaHttp.saveCompany({
        id,
        name,
        actived,
        cnpj,
        allow_duplicated_ean,
        oc_nf_dev_total,
        qte_caixas_por_pallet,
        enabled_desdobramento_produto,
        sigla,
        company_code,
        razao_social,
        phone: phone.replace(/\D/g, ''),
        address,
        number,
        district,
        city_id,
        cep,
        inscricao_estadual,
        generic_product_code,
        enviar_email_cte,
        email_destinatario_cte,
        business_unit,
      })
      onSuccess(company)
    } catch (error) {
      onError(errorHandler(error))
    }
  }

  // Render
  return (
    <form className="p-grid">
      <div className="p-col-6">
        <CustomCheckbox
          onChange={value =>
            setSelectedEmpresa({ ...selectedEmpresa, allow_duplicated_ean: value })
          }
          checked={!!selectedEmpresa.allow_duplicated_ean}
        >
          Permite Código de Barra Duplicado
        </CustomCheckbox>
      </div>
      <div className="p-col-6">
        <CustomCheckbox
          onChange={value =>
            setSelectedEmpresa({ ...selectedEmpresa, enabled_desdobramento_produto: value })
          }
          checked={!!selectedEmpresa.enabled_desdobramento_produto}
        >
          Habilitar Desdobramento de Produto
        </CustomCheckbox>
      </div>
      <div className="p-col-6">
        <CustomCheckbox
          onChange={value => setSelectedEmpresa({ ...selectedEmpresa, oc_nf_dev_total: value })}
          checked={!!selectedEmpresa.oc_nf_dev_total}
        >
          Ordem Coleta: Associar Arquivo Escaneado da NF Devolução Total é Obrigatório
        </CustomCheckbox>
      </div>
      <div className="p-col-6">
        <InputText
          label="Sigla :"
          marginTop={10}
          value={selectedEmpresa.sigla}
          onChange={value => setSelectedEmpresa({ ...selectedEmpresa, sigla: value })}
        />
        <small style={{ color: 'red' }}>
          Sigla utilizada durante processo de cadastramento automático dos clientes. Esse valor deve
          ser ÚNICO
        </small>
      </div>
      <div className="p-col-6">
        <InputText
          label="Company Code - Xml Consolidado :"
          marginTop={10}
          value={selectedEmpresa.company_code}
          onChange={value => setSelectedEmpresa({ ...selectedEmpresa, company_code: value })}
        />
        <small style={{ color: 'red' }}>
          Toda empresa deve ser cadastrada como CLIENTE e associar um COMPANY_CODE associado a ela
          mesma. Esta informação será utilizada durante o processo de importação do XML Consolidado
        </small>
      </div>
      <div className="p-col-6">
        <InputText
          label="Código de Produto genérico :"
          marginTop={10}
          value={selectedEmpresa.generic_product_code}
          onChange={value =>
            setSelectedEmpresa({ ...selectedEmpresa, generic_product_code: value })
          }
        />
      </div>
      <div className="p-col-6">
        <InputText
          label="Business Unit :"
          marginTop={10}
          value={selectedEmpresa.business_unit}
          onChange={value => setSelectedEmpresa({ ...selectedEmpresa, business_unit: value })}
        />
        <small style={{ color: 'red' }}>
          Utilizada na importação "Danone - Roteiro" para converter a coluna BU / Cliente Colog do
          arquivo na empresa correspondente
        </small>
      </div>
      <div className="p-col-6">
        <CustomCheckbox
          onChange={value =>
            setSelectedEmpresa({
              ...selectedEmpresa,
              enviar_email_cte: value,
              email_destinatario_cte: value ? selectedEmpresa.email_destinatario_cte : '',
            })
          }
          checked={!!selectedEmpresa.enviar_email_cte}
        >
          Enviar email ao emitir CTE?
        </CustomCheckbox>
      </div>
      {!!selectedEmpresa.enviar_email_cte && (
        <div className="p-col-6">
          <InputText
            label="Destinatário :*"
            marginTop={10}
            value={selectedEmpresa.email_destinatario_cte}
            onChange={value =>
              setSelectedEmpresa({ ...selectedEmpresa, email_destinatario_cte: value })
            }
          />
          <small style={{ color: 'red' }}>
            Endereço de email que receberá o XML de cada CT-e emitido/cancelado desta empresa
          </small>
        </div>
      )}

      <div className="p-col-12">
        <Btn onClick={onBtnSalvarClicked}>Salvar</Btn>
      </div>
    </form>
  )
}

function TipoArquivoImportacaoTab({ empresaId, onError }) {
  // Hooks
  const [isLoading, setIsLoading] = useState(true)
  const [tipos, setTipos] = useState([])
  const [globalFilter, setGlobalFilter] = useState('')
  useEffect(() => {
    fetchTipos()
  }, [empresaId])

  // Events
  const onCheckboxClick = async (action, tipo, checked) => {
    try {
      await handleAssocTiposArquivoComEmpresa(empresaId, tipo.id, action, checked)
      const index = tipos.findIndex(t => t.id === tipo.id)
      if (index !== -1) {
        const nTipos = [...tipos]
        switch (action) {
          case 'selected':
            nTipos[index].selected = checked
            break
          case 'padrao':
            nTipos.forEach(t => (t.padrao = false))
            nTipos[index].padrao = checked
            break
          default:
            break
        }
        setTipos(nTipos)
      }
    } catch (e) {
      onError(errorHandler(e))
    }
  }

  // Helpers
  const fetchTipos = async () => {
    try {
      setIsLoading(true)
      const fetchedTipos = await getAssocTiposArquivoComEmpresa(empresaId)
      setTipos(fetchedTipos)
    } catch (e) {
      onError(errorHandler(e))
    } finally {
      setIsLoading(false)
    }
  }

  // Render
  return isLoading ? (
    <div className="text-center">
      <Loading />
    </div>
  ) : (
    <React.Fragment>
      <div style={{ fontSize: '0.8rem', color: vinho }}>
        (*)sempre deve haver um tipo de arquivo <strong>padrão</strong> &nbsp; por empresa
      </div>
      <DataTable
        value={tipos}
        rows={10}
        paginator
        globalFilter={globalFilter}
        header={<CustomDataTableHeader onChange={value => setGlobalFilter(value)} />}
      >
        <Column
          header="#"
          body={tipo => (
            <CustomCheckbox
              checked={tipo.selected}
              onChange={value => onCheckboxClick('selected', tipo, value)}
            />
          )}
          style={tableCellCentered(80)}
        />
        <Column field="id" header="Código" style={tableCellCentered(80)} />
        <Column field="name" header="Arquivo de Importação" />
        <Column field="tipo" header="Tipo" style={tableCellCentered()} />
        <Column
          header="Ativo"
          body={tipo => <CustomCheckbox checked={tipo.ativo === 1} disabled={true} />}
          style={tableCellCentered(80)}
        />
        <Column
          header="Padrão"
          body={tipo => (
            <CustomCheckbox
              checked={tipo.padrao}
              onChange={value => onCheckboxClick('padrao', tipo, value)}
            />
          )}
          style={tableCellCentered(80)}
        />
      </DataTable>
    </React.Fragment>
  )
}

function CnpjsSecundariosTab({ empresa, dispatch }) {
  const [cnpjs, setCnpjs] = useState([])
  const [newCnpj, setNewCnpj] = useState('')

  useEffect(() => {
    if (empresa && empresa.id) {
      CompanyCnpjHttp.getCompanyCnpjs(empresa.id)
        .then(data => setCnpjs(data))
        .catch(err => dispatch(showMessageBox(null, err)))
    } else {
      setCnpjs([])
    }
  }, [empresa])

  const onAddCnpj = async () => {
    if (!newCnpj || newCnpj.length !== 14) {
      return dispatch(showMessageBox(null, 'Informe um CNPJ válido'))
    }
    try {
      dispatch(showLoadingBox('Aguarde...'))
      const saved = await CompanyCnpjHttp.saveCompanyCnpj(empresa.id, newCnpj)
      setCnpjs(prev => [...prev, saved])
      setNewCnpj('')
    } catch (err) {
      dispatch(showMessageBox(null, err))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  const onDeleteCnpj = async row => {
    try {
      dispatch(showLoadingBox('Aguarde...'))
      await CompanyCnpjHttp.deleteCompanyCnpj(row.id)
      setCnpjs(prev => prev.filter(c => c.id !== row.id))
    } catch (err) {
      dispatch(showMessageBox(null, err))
    } finally {
      dispatch(hideLoadingBox())
    }
  }

  return (
    <div className="p-grid">
      <div className="p-md-8 p-col-12">
        <InputCnpj
          label="CNPJ:"
          marginTop={10}
          value={newCnpj}
          onChange={({ value }) => setNewCnpj(value)}
        />
      </div>
      <div className="p-md-4 p-col-12" style={{ display: 'flex', alignItems: 'flex-end' }}>
        <Btn style={{ marginBottom: 0 }} onClick={onAddCnpj}>
          Adicionar
        </Btn>
      </div>
      <div className="p-col-12">
        <DataTable value={cnpjs} paginator={true} rows={5}>
          <Column field="cnpj" header="CNPJ" body={row => <Cnpj>{row.cnpj}</Cnpj>} />
          <Column
            header=""
            style={tableCellCentered(80)}
            body={row => (
              <BtnIcon onClick={() => onDeleteCnpj(row)}>
                <FaRegTrashAlt color="red" size={18} />
              </BtnIcon>
            )}
          />
        </DataTable>
      </div>
    </div>
  )
}

function EmpresaDataTable({ empresas, onRowClick }) {
  const [globalFilter, setGlobalFilter] = useState('')
  return (
    <DataTable
      value={empresas}
      selectionMode="single"
      onSelectionChange={e => onRowClick(e.value)}
      paginator
      rows={10}
      globalFilter={globalFilter}
      header={<CustomDataTableHeader onChange={setGlobalFilter} />}
    >
      <Column field="id" header="Código" style={tableCellCentered(80)} />
      <Column field="name" header="Empresa" />
      <Column
        field="cnpj"
        header="CNPJ"
        style={{ textAlign: 'center', width: 200 }}
        body={rowData => <Cnpj>{rowData.cnpj}</Cnpj>}
      />
      <Column
        field="actived"
        header="Ativo"
        style={{ textAlign: 'center', width: 100 }}
        body={rowData => <CustomCheckbox disabled checked={rowData.actived} />}
      />
    </DataTable>
  )
}

export default connect()(withRouter(Empresa))
